module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAmBAMAAAAy4HalAAAAG1BMVEVHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABp4cHsAAAACXRSTlMAWApNFy86QyOYT8wmAAAAgUlEQVQY02NwD2CAg0AxBFtdMAnOZioUV4Bz2ASNkHQIO8DZrIImCIlGwQY4m0NQAiHhLIiwkMVQFCGhLJiA3UI1wSKEqkRhBRwWIrmEQ1AIIeGIZAczkgcTJZD8moBwkhg2pyJ7IRDhNSQXMCG5TB3hYmTzHHGZ50C8eShxhBR3AADzEsMqiUOoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/person_righr.png
// module id = w4hS
// module chunks = 1